import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Education from './components/Education';
import Projects from './components/Projects';
import Resume from './components/Resume';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-black text-white bg-grid bg-grid">
      <Navbar />
      <main className="max-w-4xl mx-auto px-4 pt-20">
        <Hero />
        <About />
        <Education />
        <Experience />
        <Projects />
        <Resume />
        <Footer />
      </main>
    </div>
  );
}

export default App;